export async function getFreeCampaignAvailability(API, signal) {
    if (!API) return false;
    try {
        const response = await fetch(`${API}/api/free_campaign_availability`, {
            cache: 'no-store', signal,
        });
        if (!response.ok) return false;
        const result = await response.json();
        return result.code === 200 && result.data?.available === true;
    } catch {
        return false;
    }
}
